const API_BASE_URL =
  process.env.REACT_APP_NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_API_URL
    : process.env.REACT_APP_DEV_API_URL;

export const API_URL = `${API_BASE_URL}api/v5.0.1/`;
